export class PaymentDataGttCaixa {
    private _endPoint: string;
    private _reference: string;
    private _origin: string;
    private _url: string;
    private readonly _referencePaymentUrlParam: string = 'REF_ENT_PAGO_STC';
    private readonly _originUrlParam: string = 'ORIGEN';

    constructor(data: any) {
        this._endPoint = data.endPoint;
        this._reference = data.reference;
        this._origin = data.origin;
    }

    public get url() {
        this._url =`${this._endPoint}&${this._referencePaymentUrlParam}=${this._reference}&${this._originUrlParam}=${this._origin}`;

        return this._url;
    }
}
